<template name="footerExternal">
  <footer :class="isLoginPage ? 'login-footer' : 'page-footer'">
    <p>{{$t('Copyright')}}</p>
  </footer>
</template>
<script>
export default {
  name: 'footerExternal',
  props: {
    isLoginPage: Boolean,
  },
};
</script>
<style lang="scss" scoped>
@import '../scss/variables.scss';
.login-footer {
  color: rgba(255,255,255,0.6);
  font-size: 12px;
  padding: 25px 0;
  border-top: 1px solid rgba(240,241,242,0.3);
  line-height: 1;
  text-align: center;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  p {
    margin: 0;
  }
  @include respond-to('sm-max') {
    color: #808080;
    font-size: 11px;
    padding: 20px 0;
    border: none;
  }
  @include respond-to('ml') {
    color: #808080;
    font-size: 11px;
    padding: 20px 0;
    border: none;
  }
}
.page-footer {
  display: block;
  font-size: 12px;
  padding: 21px 0;
  background: #fff;
  box-shadow: 0 0 15px rgba(100, 100, 100, 0.15);
  line-height: 1;
  text-align: center;
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  color: #808080;
  z-index: 15;
  p {
    margin: 0;
  }
  @include respond-to('sm-max') {
    display: none;
  }
  @include respond-to('ml') {
    display: none;
  }
}
.show-invite-list {
  .page-footer {
    z-index: 99;
  }
}
.page-training {
  .page-footer {
    position: static;
  }
}
</style>